import { CSSProperties } from 'react';
import styles from './screenModal.module.css';

interface Props {
  children: React.ReactNode
  style?: CSSProperties
  customStyles?: CSSProperties
  handleCancel?: () => void;
}

function Component({
  children, style, customStyles, handleCancel,
}:Props) {
  return (
    <div className={styles.alertBox} style={{ display: 'block', ...style }}>
      <div
        className={styles.modalContainer}
        role="dialog"
        onClick={handleCancel}
      >
        <div className={[styles.modal1].join(' ')} style={customStyles} role="dialog" onClick={(e) => e.stopPropagation()}>
          {children}
        </div>
      </div>
    </div>
  );
}

export default Component;
